<template>
    <div class="tags" v-if="showTags">
      <div class="scroll-wrap"  ref="scrollWrap" @wheel.prevent="scroll">
        <ul ref="scrollCont" :style="{left: left + 'px'}">
            <li class="tags-li" v-for="(item,index) in tagsList" :class="{'active': isActive(item.path)}" :key="index">
                <router-link :to="item.path" class="tags-li-title">
                    {{item.title}}
                </router-link>
                <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-close"></i></span>
            </li>
        </ul>
      </div>
        
      <div class="tags-close-box">
          <el-dropdown @command="handleTags">
              <el-button size="mini" type="primary">
                  标签选项<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu size="small" slot="dropdown">
                  <el-dropdown-item command="other">关闭其他</el-dropdown-item>
                  <el-dropdown-item command="all">关闭所有</el-dropdown-item>
              </el-dropdown-menu>
          </el-dropdown>
      </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tagsList: [],
                left: 0,
                wheelSpeed: 30,
            }
        },
        methods: {
            isActive(path) {
                return path === this.$route.path;
            },
            scroll(e){
                const scrollWrapWidth = this.$refs.scrollWrap.offsetWidth
                const scrollContWidth = this.$refs.scrollCont.offsetWidth
                if(scrollContWidth > scrollWrapWidth){
                    // 统一不同浏览器下wheel事件的滚动值
                    // chrome/FF/Edge/IE11/IE10/IE9
                    // e.deltaY > 0 即鼠标滚轮向下滚动，则该条向右滚动，left值变负
                    const scrollSpace = e.deltaY > 0 ? -1 * this.wheelSpeed : this.wheelSpeed
                    if(e.deltaY > 0){ 
                        if(Math.abs(this.left + scrollSpace) <= (scrollContWidth - scrollWrapWidth)){
                            this.left += scrollSpace
                        }
                    } else {
                        if(this.left + scrollSpace < 0){
                            this.left += scrollSpace
                        } else {
                            this.left = 0
                        }
                    }
                } else {
                    return
                }
            },
            // 关闭单个标签
            closeTags(index) {
                const delItem = this.tagsList.splice(index, 1)[0];
                const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
                if (item) {
                    delItem.path === this.$route.path && this.$router.push(item.path);
                }else{
                    this.$router.push('/ups/equipmentSituation');
                }
            },
            // 关闭全部标签
            closeAll(){
                this.tagsList = [];
                this.$router.push('/ups/equipmentSituation');
            },
            // 关闭其他标签
            closeOther(){
                const curItem = this.tagsList.filter(item => {
                    return item.path === this.$route.path;
                })
                this.tagsList = curItem;
            },
            // 设置标签
            setTags(route){
                const isExist = this.tagsList.some(item => {
                    return item.path === route.path;
                })
                !isExist && this.tagsList.push({
                    title: route.meta.title,
                    path: route.path
                })
            },
            handleTags(command){
                command === 'other' ? this.closeOther() : this.closeAll();
            }
        },
        computed: {
            showTags() {
                return this.tagsList.length > 0;
            }
        },
        watch:{
            $route(newValue, oldValue){
                this.setTags(newValue);
            }
        },
        created(){
            this.setTags(this.$route);
        }
    }

</script>


<style lang="scss">
    .tags {
        position: relative;
        height: 40px;
        display: flex;
        align-items: center;
        background: #fff;
        box-shadow: 0 0 2px rgba(0, 0, 0, .1)
    }
    .scroll-wrap{
        position: relative;
        width: calc(100% - 107px);
        height: 100%;
        white-space: nowrap;
        overflow: hidden;
        padding: 6px 0;
    }

    .tags ul {
        box-sizing: border-box;
        // width: 100%;
        position: absolute;
        padding-left: 7px;
        padding-right: 240px;
        white-space: nowrap;
        transition: all .3s ease;
    }

    .tags-li {
        // float: left;
        display: inline-block;
        margin: 1px 5px 2px 3px;
        border-radius: 3px;
        font-size: 12px;
        overflow: hidden;
        cursor: pointer;
        // height: 24px;
        line-height: 24px;
        border: 1px solid #e9eaec;
        background: #fff;
        padding: 0 5px 0 12px;
        vertical-align: middle;
        color: #666;
        -webkit-transition: all .3s ease-in;
        -moz-transition: all .3s ease-in;
        transition: all .3s ease-in;
    }

    .tags-li:not(.active):hover {
        background: #f4f4f4;
    }

    .tags-li.active {
        color: #409EFF;
        background-color: #ecf5ff;
        border-color: #409EFF;
    }

    .tags-li-title {
        float: left;
        max-width: 80px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
        color: #666;
    }

    .tags-li.active .tags-li-title {
        color: #409EFF;
    }

    .tags-close-box {
        position: absolute;
        right: 0;
        /* top: 0; */
        box-sizing: border-box;
        /* padding-top: 1px; */
        text-align: center;
        /* width: 110px; */
        /* height: 30px; */
        background: #fff;
        margin-right: 10px;
        /* box-shadow: 0 0 2px 0px rgba(0, 0, 0, .1); */
        z-index: 10;
    }

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue